import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from "react";
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from "reactstrap";
export default (function (_ref) {
  var items = _ref.items,
    setField = _ref.setField,
    selectedKey = _ref.selectedKey,
    readonly = _ref.readonly,
    placeholder = _ref.placeholder,
    errorText = _ref.errorText;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var stylesDropdownWrapper = {
    lineHeight: "105%",
    minHeight: "1.7rem",
    paddingBottom: "0.45rem"
  };
  var stylesDropdownMenuWrapper = {
    overflowY: "auto",
    maxHeight: "400px"
  };
  var onChange = function onChange(e) {
    if (e.target.value === undefined) return;
    setField(e.target.value);
  };
  var renderOptions = function renderOptions(fields) {
    var isGroupItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return Object.keys(fields).map(function (fieldKey) {
      var field = fields[fieldKey];
      var items = field.items,
        path = field.path,
        label = field.label,
        disabled = field.disabled,
        matchesType = field.matchesType;
      var groupPrefix = level > 0 ? "\xA0\xA0".repeat(level) : "";
      var prefix = level > 1 ? "\xA0\xA0".repeat(level - 1) : "";
      if (items) {
        return /*#__PURE__*/React.createElement("div", {
          key: "dropdown-itemGroup-".concat(path)
        }, /*#__PURE__*/React.createElement(DropdownItem, {
          header: true,
          key: "".concat(path, "-header"),
          onClick: onChange,
          value: path
        }, groupPrefix + label), renderOptions(items, true, level + 1));
      } else {
        var itemText = matchesType ? /*#__PURE__*/React.createElement("b", null, prefix + label) : prefix + label;
        return /*#__PURE__*/React.createElement(DropdownItem, {
          disabled: disabled,
          key: path,
          onClick: onChange,
          value: path,
          className: isGroupItem ? "px-4" : undefined,
          active: selectedKey == path
        }, itemText);
      }
    });
  };
  var hasValue = selectedKey != null;
  var renderNotSelected = function renderNotSelected() {
    var text = placeholder || errorText || "&nbsp;";
    if (errorText) {
      return /*#__PURE__*/React.createElement("span", {
        style: {
          color: "red"
        }
      }, text);
    }
    return /*#__PURE__*/React.createElement("span", null, text);
  };
  var renderSelected = function renderSelected(allItems, selectedKey) {
    var _find2;
    if (!readonly && !selectedKey) return placeholder;
    var _find = function _find(subItems) {
      for (var k in subItems) {
        var item = subItems[k];
        if (item.path === selectedKey) {
          return item;
        }
        if (item.items) {
          var maybeFound = _find(item.items);
          if (maybeFound) {
            return maybeFound;
          }
        }
      }
    };
    return ((_find2 = _find(allItems)) === null || _find2 === void 0 ? void 0 : _find2.label) || selectedKey;
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    isOpen: isOpen,
    onClick: function onClick() {
      return !isOpen ? setIsOpen(true) : setIsOpen(false);
    },
    disabled: readonly,
    toggle: function toggle() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement(DropdownToggle, {
    tag: "button",
    className: "form-select",
    style: stylesDropdownWrapper,
    color: "transparent"
  }, hasValue ? renderSelected(items, selectedKey) : renderNotSelected()), /*#__PURE__*/React.createElement(DropdownMenu, {
    container: "body",
    style: stylesDropdownMenuWrapper
  }, !hasValue && /*#__PURE__*/React.createElement(DropdownItem, {
    key: "body",
    disabled: true,
    value: ""
  }), renderOptions(items)));
});